module.exports = __webpack_public_path__ + "img/2.e5ee8d64.jpg";